import React from 'react';
import { SWRConfig } from 'swr';

export default Comp => () => (
  <SWRConfig
    value={{
      fetcher: (...args) => fetch(...args).then(res => res.json())
    }}
  >
    <Comp />
  </SWRConfig>
);
